/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import Questionnaire from './Questionnaire';


class QuestionnaireContainer extends Component {
  render() {
    return (
      <div>
        <Questionnaire editMode={this.props.history?.location?.state?.editMode || false}/>
      </div>
    );
  }
}

export default QuestionnaireContainer;
